import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import {
  PublicWifiAccountsEntity,
  PublicWifiCreateAliasEntity,
  PublicWifiProductsEntity,
  PublicWifiRenameAliasEntity,
  PublicWifiUpdatePasswordEntity,
} from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class PublicWifiService {
  constructor() {}

  getProducts(): Observable<IEntity<any>> {
    return EntityManager.getEntity(PublicWifiProductsEntity);
  }

  getAccounts(payload: any): Observable<IEntity<any>> {
    PublicWifiAccountsEntity.customHeaders = {
      ...PublicWifiAccountsEntity.customHeaders,
      'x-application-authorization-products-data': payload.jwt,
    };
    return EntityManager.getEntity(PublicWifiAccountsEntity, {
      serviceId: payload.serviceId,
    });
  }

  updateAlias(payload: any): Observable<IEntity<any>> {
    const value = {
      technicalLoginId: payload.technicalLoginId,
      login: payload.login,
      oldLogin: payload.oldLogin,
    };
    const iEntity = EntityManager.createEntity(PublicWifiRenameAliasEntity, {});
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }

  createAlias(payload: any): Observable<IEntity<any>> {
    const value = {
      technicalLoginId: payload.technicalLoginId,
      login: payload.login,
      password: payload.password,
    };
    const iEntity = EntityManager.createEntity(PublicWifiCreateAliasEntity, {});
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }

  updatePassword(payload: any): Observable<IEntity<any>> {
    const value = {
      technicalLoginId: payload.technicalLoginId,
      password: payload.password,
    };
    const iEntity = EntityManager.createEntity(
      PublicWifiUpdatePasswordEntity,
      {},
    );
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }
}
